<template>
    <section>
        <el-button type="text" @click="openSignatureOptions = true">Sign</el-button>
        <x-modal
            v-if="openSignatureOptions"
            @close="openSignatureOptions = !openSignatureOptions"
            okText="Adopt and Sign">
            <div slot="title">Confirm your name and signature</div>
            <div class="container-fluid">
                <div class="row">
                    <el-form class="col-12">
                        <div class="row">
                            <el-form-item label="Verify Name" class="col-12 col-md-6">
                                <el-input v-model="appl.full_name" v-if="appl" @input="drawFromText"></el-input>
                            </el-form-item>
                            <el-form-item label="Date" class="col-12 col-md-6">
                                <el-input v-model="date" id="date" readonly></el-input>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <el-tabs @tab-click="updateSignatureType">
                    <el-tab-pane label="System Design">
                        <div class="col-12 col-md-4 mt-3 mt-sm-0" v-if="!isDraw" id="notdraw">
                            <select
                                class="select-belt"
                                v-model="selectedFont"
                                style="float:right;"
                                @change="drawFromText">
                                <option :value="font" v-for="font in fonts" :key="font">{{ font }}</option>
                            </select>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="Draw Signature">
                        <div class="card mt-1" id="sign-pad">
                            <div class="row">
                                <div
                                    class="col-12 d-flex flex-column position-relative"
                                    id="signature-pad-outer-div"
                                    ref="signature_pad_outer_div">
                                    <label
                                        for="signature"
                                        style="font-weight: bold;"
                                        v-if="isDraw && contractSignature"
                                    >Sign Here Using Your Mouse or Touch Screen ( Your Contract will be signed in all
                                        the correct places).</label>

                                    <label
                                        for="signature"
                                        style="font-weight: bold;"
                                        v-if="isDraw && !contractSignature"
                                    >Sign Here Using Your Mouse or Touch Screen.</label>

                                    <canvas
                                        id="signature-pad-1"
                                        ref="signature_pad_1"
                                        class="signature-pad"
                                        style="border: 1px solid #CDD4DA; border-radius: 5px;"
                                        widht="400"
                                        height="200"
                                    ></canvas>
                                    <button
                                        class="btn-red position-absolute"
                                        id="signature-pad-clear-btn"
                                        style="top: 179px; right: 23px;"
                                        v-if="isDraw"
                                        @click="erase"
                                    >Erases Signature
                                    </button>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </x-modal>
    </section>
</template>

<script>
import VueQrious from 'vue-qrious'
import SignaturePad from "signature_pad";
import {mapGetters} from 'vuex';

export default {
    name: 'CustomSignaturePad',
    components: {
        VueQrious
    },
    props: {
        submitUrl: {
            type: String,
        },
        saveSignatureUrl: {
            type: String,
        },
        applicant: {
            type: Object,
            required: true
        },
        contractSignature: {
            type: Object,
        },
        timelineUrl: {
            type: String,
        },
        verificationSignature: {
            type: Boolean,
            required: false
        },
        title: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            openSignatureOptions: false,
            agree: false,
            showPad: true,
            submitted: false,
            loading: false,
            date: this.$moment(new Date()).format("DD/MM/YYYY"),
            sig1: null,
            appl: null,
            c1: null,
            signatureType: 'Draw Signature',
            selectedFont: "Bad Script",
            fonts: [
                "Bad Script",
                "Homemade Apple",
                "Mr De Haviland",
                "Sacramento"
            ]
        }
    },
    computed: {
        ...mapGetters({
            customerSignature: 'signature/getCustomerSignature'
        }),
        isDraw() {
            if (this.signatureType == 'System Design') return false;
            return true;
        }
    },
    watch: {
        isDraw(newVal, oldVal) {
            this.sig1.clear();
            if (!newVal) {
                //   on update from switch
                this.drawFromText();
            }
        },
        selectedFont(newVal, oldVal) {
        }
    },
    ready: function () {
        window.addEventListener("resize", this.handleResize);
    },
    mounted() {
        this.appl = this.applicant;
        this.appl.full_name = `${this.appl.first_name} ${this.appl.last_name}`;
        this.c1 = this.$refs.signature_pad_1;
        this.sig1 = new SignaturePad(this.c1, {
            // backgroundColor: "rgba(255, 255, 255, 0)"
        });
        this.handleResize();
        this.showPad = true;
    },

    updated() {
    },
    activated() {
    },
    methods: {
        sendCustomerSignatureSMS() {
            alert('Send SMS with signature link')
        },
        updateSignatureType(tab, event) {
            this.signatureType = tab.label;
        },
        drawFromText() {
            if (!this.isDraw) {
                this.sig1.clear(); // always clear on update text;
                let context = this.c1.getContext("2d");
                if (this.selectedFont == 'Bad Script') context.font = "40px " + this.selectedFont;
                else if (this.selectedFont == 'Homemade Apple') context.font = "30px " + this.selectedFont;
                else context.font = "50px " + this.selectedFont;
                context.textAlign = 'center'
                context.fontWeight = '700px'
                context.fillText(this.appl.full_name, 250, 200);
            }
        },
        saveSignature() {
            if (this.isDraw && this.sig1.isEmpty()) {
                // alert("Please provide a signature first.");
                this.$message({message: "Please provide a signature first.", type: "error"})
                return false
            }

            let canvas = this.isDraw ? this.sig1 : this.c1;
            let data = canvas.toDataURL("image/png");
            let sig = this.download(data);
            let formData = new FormData();

            formData.append("signature", sig);
            formData.append("name", this.appl.full_name);
            formData.append("date", this.date);
            axios
                .post(this.saveSignatureUrl, formData, {
                    headers: {"Content-Type": "multipart/form-data"}
                })
                .then(res => {
                    this.$store.dispatch("signature/saveCustomerSignature", res.data);
                    this.$bus.$emit("add-signature", true);
                    this.$bus.$emit("close-modal", true);
                    if (this.verificationSignature) this.$bus.$emit("verified", true);
                })
                .catch(err => {
                    this.$message({
                        message: "Cannot Submit Contract Signature",
                        type: "error"
                    });
                    console.error(err);
                });
        },
        dataURLToBlob(dataURL) {
            // Code taken from https://github.com/ebidel/filer.js
            var parts = dataURL.split(";base64,");
            var contentType = parts[0].split(":")[1];
            var raw = window.atob(parts[1]);
            var rawLength = raw.length;
            var uInt8Array = new Uint8Array(rawLength);

            for (var i = 0; i < rawLength; ++i) {
                uInt8Array[i] = raw.charCodeAt(i);
            }

            return new Blob([uInt8Array], {type: contentType});
        },
        download(dataURL) {
            let blob = this.dataURLToBlob(dataURL);
            return blob;
        },

        /**
         * @deprecated
         */
        submit() {
            if (this.sig1.isEmpty()) {
                return alert("Please provide a signature first.");
            }
            this.submitted = true;
            this.loading = true;
            let data = this.sig1.toDataURL("image/png");
            let sig = this.download(data);
            let formData = new FormData();
            formData.append("signature", sig);
            formData.append("name", this.appl.full_name);
            formData.append("date", this.date);
            axios
                .post(this.submitUrl, formData, {
                    headers: {"Content-Type": "multipart/form-data"}
                })
                .then(res => {
                    this.submitted = true;
                    this.loading = false;
                    this.$message({
                        message: "Signature Saved",
                        type: "success"
                    });

                    window.location.href = this.timelineUrl;
                })
                .catch(err => {
                    this.submitted = false;
                    this.loading = false;
                    this.$message({
                        message: "Cannot Submit Contract Signature",
                        type: "error"
                    });
                    console.error(err);
                });
        },
        erase() {
            this.sig1.clear();
        },
        handleResize() {
            let data = this.sig1.toData();

            let width = _.get(this.$refs.signature_pad_outer_div, "clientWidth")
            let height = width / 2
            this.c1.width = width
            this.c1.height = height
            this.sig1.clear()

            this.sig1.fromData(data)
        }
    }
}
</script>

<style lang="scss" scoped>
.rotate-screen {
    display: none;
}

@media screen and (min-width: 320px) and (max-width: 767px) and (orientation: portrait) {
    .rotate-screen {
        display: flex !important;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        width: 100vw;
        height: 100vh;
        overflow-x: hidden;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 10000;
    }
}
</style>
